var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftBreadcrumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94248 8.00065L10.4711 4.47206C10.7314 4.21171 10.7314 3.7896 10.4711 3.52925C10.2107 3.2689 9.78862 3.2689 9.52827 3.52925L5.52827 7.52925C5.26792 7.7896 5.26792 8.21171 5.52827 8.47205L9.52827 12.4721C9.78862 12.7324 10.2107 12.7324 10.4711 12.4721C10.7314 12.2117 10.7314 11.7896 10.4711 11.5292L6.94248 8.00065Z",
    fill: "#495680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftBreadcrumbs);
export default __webpack_public_path__ + "static/media/iconLeftBreadcrumbs.10d3874baf98968c0e136283456e08eb.svg";
export { ForwardRef as ReactComponent };